/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect } from 'react';

// redux
import { useSelector, useDispatch } from 'react-redux';

// thunks
import {fetchDashboardMessage, fetchLatestProductRevenueDeduction, fetchLatestProductRevenueDeductionForAccount} from "../../../../state/thunks/settings";

// material
import SettingsHeader from "../settingsHeader";
import { Page, Content, InContentMessage } from '@insticator/insticator-ui';
import PageHeader from "../../../../material/structure/pageheader/pageheader";
import PageContent from "../../../../material/structure/pagecontent/pagecontent";

// pages
import UsageFees from "./usagefees/usagefees";
import SectionLoader from "../../../../material/sectionloader/sectionloader";
import Notifications from "./notifications/notifications";

/* ========== ~~~~~~~~~~ BILLINGS PAGE ~~~~~~~~~~ ========== */
const InsticatorPlatformPage = props => {
  const dispatch = useDispatch()
  const accountUUID = useSelector((state) => state.session.accountUUID)
  const usageFeesUpdateStatus = useSelector((state) => state.settings.usageFeesUpdateStatus)
  const usageFeesUpdateStatusForAccount = useSelector((state) => state.settings.usageFeesUpdateStatusForAccount)
  const notificationsUpdateStatus = useSelector((state) => state.settings.notificationsUpdateStatus)

  useEffect(() => {
    const localeDate = new Date().toISOString().split('T')[0]
    dispatch(fetchLatestProductRevenueDeduction(localeDate))
    dispatch(fetchLatestProductRevenueDeductionForAccount({localeDate,accountUUID}))
    dispatch(fetchDashboardMessage())
  }, [])

  return (
    <Page>
      <SettingsHeader />
      <Content>
        <InContentMessage />
        <PageHeader title={'COOL Media Platform'} />
        <PageContent>
          {(usageFeesUpdateStatus === 'pending' || usageFeesUpdateStatusForAccount === 'pending')
          ? <SectionLoader />
          : <UsageFees/>
          }
          {notificationsUpdateStatus === 'pending'
          ? <SectionLoader />
          : <Notifications />}
        </PageContent>
      </Content>
    </Page>
  )
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default InsticatorPlatformPage;